import { RANK_TYPES, useTopPostsControls } from './useTopPostsControls.hook';
import styled, { ThemeContext } from 'styled-components';
import DrawerSectionHeading from '../DrawerSectionHeading';
import SortableTopPosts from './SortableTopPosts';
import Stack from '../Stack';
import ToggleWatch from 'components/Button/ToggleWatch';
import TopPostsDownloadButton from './TopPostsDownloadButton';
import { useContext } from 'react';
import { useCurrentCountry } from 'utils/hooks';
import { useTopPostsRelatedHashtags } from 'utils/hooks/api';
import { v4 as uuid } from 'uuid';

const rankTypes = [RANK_TYPES.LAST_WEEK_VIEWS, RANK_TYPES.TOTAL_POST_VIEWS];

const TopPostsBtnContainer = styled.div`
    border-color: ${({ theme }) => theme.gray_5};
    flex: 1;
    padding: 0;
    display: flex;
    justify-content: center;
`;

function TopPostsDrawer({
    year,
    week,
    countries,
    categories,
    brands,
    hashtags,
    displayQty = 5,
    name,
    showAddToWatchlist = true,
    hashtagName,
}) {
    const theme = useContext(ThemeContext);
    const country = useCurrentCountry();
    const {
        sortSelect,
        value,
        defaultSortOption,
        visibleOrderedMetrics,
        columnsMenu,
    } = useTopPostsControls({
        week,
        year,
        mixpanelContext: 'TopPostsSortSelect',
        tableName: 'top-posts-section-card',
        rankTypes,
    });
    const topPostsQuery = useTopPostsRelatedHashtags({
        year: value.year,
        week: value.week,
        countries,
        categories,
        brands,
        hashtags,
        rank_type: value.apiRankType,
    });
    return (
        <Stack $space="1rem">
            <Stack
                $direction="row"
                $space="15px"
                css="display: flex; align-items: center;"
            >
                <DrawerSectionHeading>
                    <span css="display: flex; align-items: center;">
                        Top Posts
                    </span>
                </DrawerSectionHeading>
                <span css="margin-left: auto;">
                    <TopPostsDownloadButton
                        year={value.year}
                        week={value.week}
                        name={name}
                        country={country}
                        source="tiktok"
                        topPostsQuery={topPostsQuery}
                        visibleOrderedMetrics={visibleOrderedMetrics}
                    />
                </span>
            </Stack>
            <Stack
                css="display: flex; justify-content: space-between;"
                $space=".25rem"
                $direction="row"
            >
                {sortSelect}
                {columnsMenu}
            </Stack>
            <SortableTopPosts
                topPostsQuery={topPostsQuery}
                displayQty={displayQty}
                sortOption={defaultSortOption}
                visibleOrderedMetrics={visibleOrderedMetrics}
            />
        </Stack>
    );
}

export default TopPostsDrawer;
